import * as React from "react";

import { PlpSelectedFacetOption, PresentationFacet } from "../model";

import {
  useProductListState,
  useProductListController_forFiltering,
  usePlpPresenterForTheFilterMenu_AnyBreakpoint,
} from "../providers";

import { SelectedOption } from "../selected-option";

interface FilterSelectedOptionsProps {
  facet: PresentationFacet | undefined;
  uncategorized: boolean;
}

export const FilterSelectedOptions: React.FunctionComponent<
  FilterSelectedOptionsProps
> = (props) => {
  const { facet, uncategorized } = props;

  const { selectedOptions: allSelectedOptions } = useProductListState();
  const { getSelectedOptionsOfFacet, getUncategorizedSelectedOptions } =
    useProductListController_forFiltering();

  const { handleRemoveSelectedFilterOption } =
    usePlpPresenterForTheFilterMenu_AnyBreakpoint();

  const selectedOptions: PlpSelectedFacetOption[] = React.useMemo(() => {
    if (!facet && !uncategorized) {
      return [];
    }
    let selectedOptions: PlpSelectedFacetOption[] = [];
    if (uncategorized) {
      selectedOptions = getUncategorizedSelectedOptions();
    } else if (facet) {
      selectedOptions = getSelectedOptionsOfFacet(facet);
    }
    return selectedOptions;
  }, [facet, allSelectedOptions]);

  const handleAction = (
    event: React.MouseEvent,
    selectedOption: PlpSelectedFacetOption
  ) => {
    event.stopPropagation();
    event.preventDefault();

    handleRemoveSelectedFilterOption(selectedOption);
  };

  if (selectedOptions.length < 1) {
    return null;
  }

  return (
    <div className="selected-options-container">
      {selectedOptions.map((selectedOption) => (
        <SelectedOption selectedOption={selectedOption} action={handleAction} />
      ))}
    </div>
  );
};
